import { Hero } from '@/components/hero';
import { CapabilitiesSection, DownloadSection } from '@/components/home-sections';
import { SiteFooter } from '@/components/site-footer';
import { SiteHeader } from '@/components/site-header';
import { StatsSection } from '@/components/stats-section';
import { OpenSourceSection } from '@/components/open-source-section';
import { FAQSection } from '@/components/faq-section';
import { WaitlistSection } from '@/components/waitlist-section';
import { UseCaseDemosSection } from '@/components/use-case-demos-section';

export function LandingPage() {
  return (
    <div className="min-h-screen bg-background">
      <a
        href="#main-content"
        className="skip-link"
      >
        跳转到主要内容
      </a>
      <SiteHeader />
      <Hero />
      <main id="main-content">
        <div className="bg-card/30">
          <StatsSection />
        </div>
        <div className="section-divider" />
        <div className="bg-background">
          <CapabilitiesSection />
        </div>
        <div className="section-divider" />
        <div className="bg-card/30">
          <UseCaseDemosSection />
        </div>
        <div className="section-divider" />
        <div className="bg-background">
          <OpenSourceSection />
        </div>
        <div className="section-divider" />
        <div className="bg-card/30">
          <FAQSection />
        </div>
        <div className="section-divider" />
        <div className="bg-background">
          <WaitlistSection />
        </div>
        <DownloadSection />
      </main>
      <SiteFooter className="mx-auto w-full max-w-7xl border-t border-border/40" />
    </div>
  );
}
